export default __webpack_public_path__ + "static/media/pet-cloud-logo.ae9fdda1.svg";